import { render, staticRenderFns } from "./DownloadSection.vue?vue&type=template&id=78e4bef0&scoped=true"
var script = {}
import style0 from "./DownloadSection.vue?vue&type=style&index=0&id=78e4bef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e4bef0",
  null
  
)

export default component.exports